import { TEXT_MUTED } from '../../lib/medievalTheme';
import { getClass } from '../../utils/arena/classes';
import { t } from '../../localization/t';
import { VialGauge } from './ForesightGauge';

const CLS = getClass('battlemage');
const ACCENT = CLS.accent;
const LIT_COUNT = '#ffd9d3';

// Rush of Battle as a row of stack medallions: the class's major ornament
// (white on black, read in luminance like the header button), lit in the
// accent for each stack held, iron for each still to earn. With no cap
// (The Conquest Continues) the row is the held stacks alone.
export function RushStacks({ rush = 0, max = 3, size = 1 }) {
  const slots = max == null ? Math.max(rush, 1) : Math.max(max, rush);
  const d = 2.25 * size;
  return (
    <div className="flex items-center" style={{ gap: `${0.5 * size}cqw` }} data-testid="rush-stacks" data-rush={rush}>
      {Array.from({ length: slots }, (_, i) => {
        const lit = i < rush;
        return (
          <div
            key={i}
            className="relative rounded-full"
            style={{
              width: `${d}cqw`, height: `${d}cqw`,
              background: lit ? `${ACCENT}26` : 'rgba(14,12,8,0.75)',
              boxShadow: lit
                ? `0 0 0 1px ${ACCENT}b3, 0 0 ${0.75 * size}cqw ${ACCENT}66, inset 0 0 ${0.5 * size}cqw ${ACCENT}33`
                : '0 0 0 1px rgba(201,168,76,0.3), inset 0 1px 0 rgba(0,0,0,0.8)',
              transitionProperty: 'box-shadow, background-color', transitionDuration: '300ms',
            }}
          >
            <span
              aria-hidden
              className="vh-skill-capstone-ornament"
              style={{ inset: `${0.35 * size}cqw`, '--vh-capstone-ornament-svg': `url("${CLS.majorOrnament}")`, '--vh-capstone-ornament-color': lit ? ACCENT : 'rgba(166,160,155,0.28)' }}
            />
          </div>
        );
      })}
    </div>
  );
}

// Rush of Battle with its label and count. `size` scales the type and the
// medallions together (1 = the standing's gauge).
export function RushGauge({ rush = 0, max = 3, size = 1 }) {
  return (
    <div className="flex items-center" style={{ gap: `${0.875 * size}cqw` }} data-testid="rush-gauge">
      <span className="arena-heading whitespace-nowrap" style={{ color: ACCENT, fontSize: `${0.9375 * size}cqw`, letterSpacing: '0.04em', textShadow: `0 0 0.75cqw ${ACCENT}66` }}>
        {t('Rush of Battle')}
      </span>
      <RushStacks rush={rush} max={max} size={size * 0.8} />
      <span className="arena-heading tabular-nums" style={{ color: rush > 0 ? LIT_COUNT : TEXT_MUTED, fontSize: `${0.9375 * size}cqw`, minWidth: `${2.5 * size}cqw` }}>
        {max == null ? rush : `${rush} / ${max}`}
      </span>
    </div>
  );
}

// Banked Ferocity: label, vial, count. The same vial every class currency pours into.
export function FerocityGauge({ value = 0, max = 100, width = 22, size = 1 }) {
  return (
    <div className="flex items-center" style={{ gap: `${0.875 * size}cqw`, width: `${width}cqw` }} data-testid="ferocity-gauge">
      <span className="arena-heading" style={{ color: ACCENT, fontSize: `${0.9375 * size}cqw`, letterSpacing: '0.04em', textShadow: `0 0 0.75cqw ${ACCENT}66` }}>
        {t('Ferocity')}
      </span>
      <VialGauge className="flex-1" value={value} max={max} color={ACCENT} height={0.875 * size} notch={10} />
      <span className="arena-heading tabular-nums" style={{ color: value > 0 ? LIT_COUNT : TEXT_MUTED, fontSize: `${0.9375 * size}cqw`, minWidth: `${3.75 * size}cqw`, textAlign: 'right' }}>
        {value} / {max}
      </span>
    </div>
  );
}
